export const printersTypes = {
  GET_PRINTERS: "GET_PRINTERS",
  NEW_PRINTER: "NEW_PRINTER",
  EDIT_PRINTER: "EDIT_PRINTER",
  DELETE_PRINTER: "DELETE_PRINTER",

  ADD_PRINT_QUEUE: "ADD_PRINT_QUEUE",
  DELETE_PRINT_QUEUE: "DELETE_PRINT_QUEUE",
  PRINTING_LOADING_START: "PRINTING_LOADING_START",
  PRINTING_LOADING_STOP: "PRINTING_LOADING_STOP",
  RESTORE_PRINT: "RESTORE_PRINT"
}